{
    "type": {
        "virtual": "Virtuell",
        "physical": "Physisch"
    },
    "label": {
        "card_holder": "Karteninhaber:in",
        "monthly_limit": "monatliche Limits",
        "currency": "Währung",
        "atm_withdrawals": "Auszahlung am Geldautomaten",
        "online_payments": "Online Bezahlung",
        "account_statement": "Kontoauszüge",
        "funding_history": "Aufladungshistorie",
        "back_to_credit_card": "Zurück zur Karte",
        "back_to_credit_cards": "Zurück zu den Karten",
        "back_to_wallet": "Zurück zu Wallet",
        "load_amount": "Aufladungsbetrag",
        "date": "Datum",
        "load_type": "Art der Überweisung",
        "balance_after": "Kontostand nach der Aufladung",
        "month": "Monat",
        "opening_balance": "Eröffnungssaldo",
        "debit": "Abbuchungen",
        "credit": "Gutschriften",
        "closing_balance": "Endsaldo",
        "download": "Herunterladen",
        "documents": "Dokumente",
        "card_number": "Kartennummer",
        "year": "Jahr",
        "cvc": "CVC",
        "beneficiary": "Begünstigter",
        "iban": "IBAN",
        "bic_number": "BIC",
        "bank_name": "Bank",
        "bank_address": "Bank Adresse",
        "limit": "Limit",
        "frequency": "Zeitintervall",
        "transferred_amount": "Zu übertragender Betrag",
        "total_fund": "Gutschriften",
        "total_expense": "Abbuchungen",
        "card_name": "Kartenname oder -beschreibung"
    },
    "action": {
        "set_passcode": "Finway PIN setzen",
        "update_passcode": "Finway PIN aktualisieren",
        "show_pin": "Pin anzeigen",
        "suspend": "Temporär sperren",
        "resume": "Reaktivieren",
        "close": "Endgültig schließen",
        "report": "melden",
        "create_new": "Karte beantragen",
        "submit": "Karte beantragen",
        "wallet_funding": "Wallet Aufladung",
        "wallet_funding_via_bank_transfer": "Wallet Aufladung via Banktransfer",
        "wallet_details": "Wallet Details",
        "save_changes": "Änderungen speichern",
        "top_up_card": "Karte aufladen",
        "empty_card": "Karte leeren",
        "enroll_all_users": "Alle registrieren"
    },
    "edit": {
        "title": "Kartendetails bearbeiten",
        "budget": "Budget",
        "budget_frequency": "Budgethäufigkeit",
        "transaction_limit": "Transaktionslimit",
        "is_atm": "ATM withdrawals",
        "is_auto_recharge": "Automatische Aufladung",
        "is_balance_alert": "Benachrichtigung bei niedrigem Kontostand",
        "auto_recharge_trigger": "Automatische Aufladung bei",
        "balance_trigger": "Warnwert bei niedrigem Kontostand"
    },
    "title": "KYB (Know your business)",
    "information": "Bitte füllen Sie das Formular aus, das für die Kartenaktivierung erforderlich ist.",
    "information_2": "Der Verifizierungsprozess kann bis zu 3 Arbeitstage dauern.",
    "steps": {
        "company_details": "Details zum Unternehmen",
        "directors": "Geschäftsführer",
        "shareholders": "Inhaber"
    },
    "placeholder": {
        "card_name": "Karte für Reisekosten",
        "name_on_card": "Name des Karteninhabers"
    },
    "company_details": {
        "company_name": "Eingetragener Name des Unternehmens",
        "trading_name": "Handelsname des Unternehmens",
        "establishment_date": "Gründungsdatum",
        "tax_id": "Steuernummer",
        "incorporation_type": "Gesellschaftsform",
        "incorporation_state": "Staat der Gründung des Unternehmens",
        "incorporation_certificate": "Gründungsurkunde",
        "is_public": "Das Unternehmen ist börsennotiert",
        "yes": "Ja",
        "no": "Nein",
        "is_payment_provider": "Is payment provider",
        "primary_contact_email": "Email der Hauptkontaktsperson",
        "primary_contact_phone": "Mobilnummer der Hauptkontaktsperson",
        "address_company": "Sitz der Gesellschaft",
        "address_office": "Büroanschrift",
        "street": "Straße",
        "street_number": "Straßennummer",
        "city": "Stadt",
        "state": "Land",
        "legal_structure_chart": "Diagramm der legalen Unternehmensstruktur",
        "financial_statement": "Finanzielles Statement",
        "postal_code": "Postleitzahl",
        "country_code": "Bundesland",
        "memorandum": "Gesellschaftsvertrag oder Satzung"
    },
    "directors": {
        "title": "Direktoren oder leitende Angestellte",
        "information": "Informationen zum gesetzlichen Vertreter",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "job_title": "Berufsbezeichnung",
        "date_of_birth": "Geburtsdatum",
        "street": "Straße",
        "street_number": "Straßennummer",
        "city": "Stadt",
        "state": "Land",
        "postal_code": "Postleitzahl",
        "country_code": "Bundesland",
        "phone": "Mobiltelefonnummer",
        "email": "Email Adresse",
        "is_owner": "Ist auch wirtschaftlich Berechtigter",
        "owner": "Ja",
        "not_owner": "Nein",
        "personal_id": "Personalausweis oder Führerschein",
        "proof_of_address": "Nachweis der Adresse",
        "proof_of_address_extra": "Z.B. Kontoauszug oder Stromrechnung. Sie muss innerhalb der letzten 3 Monate datiert sein.",
        "add": "Weiteren Direktor hinzufügen",
        "remove": "Direktor entfernen",
        "date_appointed": "Ernannt am",
        "nationality": "Nationalität",
        "yes": "Ja",
        "no": "Nein",
        "is_beneficial_owner": "Ist auch wirtschaftlich Berechtigte:r",
        "is_proprietor_or_officer": "Is also proprietor or officer",
        "address_of_legal_representative": "Adresse des rechtlichen Vertreters",
        "identification": "Identifikation des Direktors",
        "identification_type": "Identifikationsart",
        "identification_value": "Ausweis- oder Reisepassnummer",
        "identification_type_id": "Ausweis",
        "identification_type_passport": "Reisepass"
    },
    "shareholders": {
        "information": "Informationen über die Inhaber",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "job_title": "Berufsbezeichnung",
        "date_of_birth": "Geburtsdatum",
        "street": "Straße",
        "street_number": "Straßennummer",
        "city": "Stadt",
        "state": "Land",
        "postal_code": "Postleitzahl",
        "country_code": "Bundesland",
        "phone": "Mobiltelefonnummer",
        "email": "Email Adresse",
        "board_member_since": "Vorstandsmitglied seit",
        "company_owner_percentage": "Anteil des Firmeninhabers am Unternehmen",
        "proof_of_address": "Nachweis der Adresse",
        "proof_of_address_extra": "Z.B. Kontoauszug oder Stromrechnung. Sie muss innerhalb der letzten 3 Monate datiert sein.“",
        "share_allotment": "(z.B. Aktienzuteilung, Aktienzertifikat des staatlichen Handelsregisters etc.)",
        "personal_id": "Personalausweis oder Führerschein",
        "attester_name": "Name des Einreichers",
        "attester_title": "Berufsbezeichnung des Einreichers",
        "attestation_date": "Datum der Einreichung der Dokumente",
        "official_document": "Offizielles oder notariell beglaubigtes Dokument über den Anteilsbesitz",
        "attestation_consent": "Einverständniserklärung",
        "add": "Einen weiteren Inhaber hinzufügen",
        "remove": "Inhaber entfernen",
        "verify_data": "Bestätigen Sie, dass die oben genannten Daten korrekt sind",
        "date_appointed": "Date appointed",
        "nationality": "Nationality",
        "yes": "Ja",
        "no": "Nein",
        "is_beneficial_owner": "Ist auch wirtschaftlich Berechtigte:r",
        "is_proprietor_or_officer": "Is also proprietor or officer",
        "address_of_legal_representative": "Adresse des rechtlichen Vertreters",
        "identification": "Identifikation des Direktors",
        "identification_type": "Identifikationsart",
        "identification_value": "Ausweis- oder Reisepassnummer",
        "identification_type_id": "Ausweis",
        "identification_type_passport": "Reisepass"
    },
    "buttons": {
        "previous": "Zurück",
        "save_for_later": "Speichern",
        "next": "Weiter",
        "send": "Senden",
        "upload": "Hochladen"
    },
    "wallet_funding": {
        "credit_card": "Karte",
        "bank_transfer": "Banküberweisung",
        "card_info": "Kartenüberweisungen werden sofort nach Freigabe durch das finway-Team bearbeitet. Bitte beachten Sie, dass bei diesem Vorgang eine Gebühr von 2 % aufgrund von Bankgebühren anfällt.",
        "finway_bank_info": "Das Wallet ist Ihr finway-Bankkonto, das mit Ihren finway-Karten verknüpft ist. Sie müssen Geld im Wallet haben, um die finway-Karten nutzen zu können. Sie können Überweisungen von Ihrem Bankkonto auf Ihr finway-Wallet direkt über finway-Tätigen, weil Ihre Bank mit finway verbunden ist."
    },
    "card_widget": {
        "balance": "Wallet-Guthaben",
        "loaded_sum": "Guthaben auf Prepaid Karten",
        "pending_transaction": "Ausstehende Transaktionen"
    },
    "frequency": {
        "daily": "Täglich",
        "weekly": "Wöchentlich",
        "monthly": "Monatlich",
        "quarterly": "Quartalsweise",
        "yearly": "Jährlich",
        "life_time": "Lebenslang",
        "one_time": "Einmalig"
    },
    "kyb_reason": {
        "action_required": "Ihre KYB-Prüfung konnte noch nicht durchgeführt werden, weil Informationen unvollständig oder nicht korrekt sind.",
        "rejected": "Ihre KYB-Prüfung wurde abgelehnt."
    },
    "incorporation_type": {
        "LLC": "LLC",
        "CORPORATION": "Kapitalgesellschaft",
        "SOLE_PROPRIETORSHIP": "Personengesellschaft",
        "PARTNERSHIP": "Gesellschaft bürgerlichen Rechts",
        "COOPERATIVE": "Genossenschaft",
        "OTHER": "Sonstiges"
    },
    "show_pin": {
        "title": "Physikalischer Karten-PIN",
        "message": "Dies ist der PIN für die physische finway-Karte."
    },
    "card_onboarding": {
        "title": "Aktivierung des Kartenprogramms",
        "description": "Sie haben sich für das Kartenprogramm Ihres Unternehmens angemeldet. Bitte schließen Sie dieses Onboarding ab, um Ihre Karte nutzen zu können.",
        "passcode": {
            "title": "Finway PIN einrichten",
            "prompt": "Bitte wählen Sie eine Finway PIN mit vier Ziffern."
        },
        "mobile_verification": {
            "title": "Überprüfung der Mobiltelefonnummer",
            "complete": "Ihre Mobiltelefonnummer wurde verifiziert."
        },
        "complete": "Sie können jetzt die finway-Karten verwenden."
    },
    "filter": {
        "all_cards": "Alle Karten",
        "active_cards": "Aktive Karten"
    }
}
